import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { getAllRouteParams } from '../../lib/get-all-route-params';
import { getFullPath } from '../../lib/get-full-path';
import { RedirectService } from '../../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryReviewGuard {
  constructor(private redirectService: RedirectService, @Inject(PLATFORM_ID) private platformId: string) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    const params = getAllRouteParams(next);
    let path = getFullPath(next);
    path = path.slice(
      0,
      path.findIndex(p => p === 'review')
    );
    if (params.assetId) path.push(params.assetId);
    return this.redirectService.redirectTo(path, params);
  }
}
